export default __webpack_public_path__ + "static/media/logo.f312a0bf.svg";